import { render, staticRenderFns } from "./BroadcastFormToolbar.vue?vue&type=template&id=2673a92e&scoped=true&"
import script from "./BroadcastFormToolbar.vue?vue&type=script&lang=ts&"
export * from "./BroadcastFormToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastFormToolbar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BroadcastFormToolbar.vue?vue&type=style&index=1&id=2673a92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673a92e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VRow,VTextField})
